import { type SVGProps } from "react";
const IconNavDash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.657 16.667H1.502A1.502 1.502 0 0 1 0 15.164V11.86a1.503 1.503 0 0 1 1.502-1.502h3.155a1.503 1.503 0 0 1 1.503 1.502v3.305a1.502 1.502 0 0 1-1.503 1.503Zm-3.155-5.309a.5.5 0 0 0-.5.501v3.305a.5.5 0 0 0 .5.501h3.155a.5.5 0 0 0 .501-.5v-3.306a.5.5 0 0 0-.5-.5H1.501ZM4.657 9.215H1.502A1.502 1.502 0 0 1 0 7.712v-6.21A1.502 1.502 0 0 1 1.502 0h3.155A1.502 1.502 0 0 1 6.16 1.502v6.21a1.502 1.502 0 0 1-1.503 1.503ZM1.502 1.002a.5.5 0 0 0-.5.5v6.21a.5.5 0 0 0 .5.501h3.155a.5.5 0 0 0 .501-.5v-6.21a.5.5 0 0 0-.5-.501H1.501ZM15.164 16.667h-6.36a1.502 1.502 0 0 1-1.502-1.503v-7A1.502 1.502 0 0 1 8.804 6.66h6.36a1.502 1.502 0 0 1 1.503 1.502v7.001a1.502 1.502 0 0 1-1.503 1.503Zm-6.36-9.005a.5.5 0 0 0-.5.501v7.001a.5.5 0 0 0 .5.501h6.36a.501.501 0 0 0 .501-.5V8.162a.5.5 0 0 0-.5-.5h-6.36ZM15.164 5.519h-6.36a1.502 1.502 0 0 1-1.502-1.503V1.502A1.502 1.502 0 0 1 8.804 0h6.36a1.503 1.503 0 0 1 1.503 1.502v2.514a1.502 1.502 0 0 1-1.503 1.503Zm-6.36-4.517a.5.5 0 0 0-.5.5v2.514a.5.5 0 0 0 .5.501h6.36a.501.501 0 0 0 .501-.5V1.501a.5.5 0 0 0-.5-.5h-6.36Z"
    />
  </svg>
);
export default IconNavDash;
